import { render, staticRenderFns } from "./DynamicSvgIcon.vue?vue&type=template&id=9534a614&scoped=true"
import script from "./DynamicSvgIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicSvgIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DynamicSvgIcon.vue?vue&type=style&index=0&id=9534a614&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9534a614",
  null
  
)

export default component.exports